/**
 * Interface of the model of the NgbTimepicker directive
 */
export interface NgbTimeStruct {
  /**
   * The hour, going from 0 to 23
   */
  hour: number;

  /**
   * The minute, going from 0 to 59
   */
  minute: number;

  /**
   * The second, going from 0 to 59
   */
  second: number;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
